/**
 * @file   src\mobile\components\Common\Sortoffcanvas.js
 * @brief  This file is responsible for sort menu
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import Offcanvas from "react-bootstrap/Offcanvas";

const Sortoffcanvas = (props) => {
  const { show, onHide, handleSortParam, options, sortParam } = props;

  return (
    <Offcanvas
      className="mobile-offcanvas sort-filter-offcanvas"
      show={show}
      onHide={onHide}
      placement="bottom"
      {...props}
    >
      <Offcanvas.Body>
        <div className="offcanvas-sort-wrap">
          <div className="sort-heading">Sort</div>
          <div className="modal-choose-property mb-0">
            {options.map((item, index) => {
              return (
                <label className="property-radio" key={index}>
                  <input
                    type="radio"
                    name="check-box-option"
                    id={item?.value}
                    value={item?.value}
                    onClick={() => {
                      handleSortParam(item);
                    }}
                    checked={sortParam?.value == item?.value}
                  />
                  <span className="heightWrap">
                    <div className="modal-wrap-info">
                      <h2 className="pb-0">{item?.label}</h2>
                    </div>
                  </span>
                </label>
              );
            })}
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};
export default Sortoffcanvas;
